import { AppThunk } from "..";
import { Action } from "redux";

export const UPDATE_BASKET_COUNT = "TIXLY_UPDATE_BASKET_COUNT";
export const UPDATE_LOGGED_IN_STATUS = "TIXLY_UPDATE_LOGGED_IN_STATUS";

interface UpdateBasketCount extends Action {
    type: typeof UPDATE_BASKET_COUNT;
    count: number;
}

export const updateBasketCount = (count: number) => {
    const action: UpdateBasketCount = {
        type: UPDATE_BASKET_COUNT,
        count: count,
    };
    return action;
};

export const updateBasketCountAsync = (count: number): AppThunk => async (dispatch) => {
    dispatch(updateBasketCount(count));
};

interface UpdateLoggedInStatus extends Action {
    type: typeof UPDATE_LOGGED_IN_STATUS;
    loggedIn: boolean;
}

export const updateLoggedInStatus = (loggedIn: boolean) => {
    const action: UpdateLoggedInStatus = {
        type: UPDATE_LOGGED_IN_STATUS,
        loggedIn: loggedIn,
    };
    return action;
};

export type TixlyActions = UpdateBasketCount | UpdateLoggedInStatus;
